"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEligibilityChoiceContent = exports.shouldSearchNonprofitRegisterAtSignup = exports.isEinSignupCountry = exports.getSignupCountryFromCountryCode = void 0;
const country_1 = require("../enums/country");
const getSignupCountryFromCountryCode = (countryCode) => {
    if (!countryCode) {
        return undefined;
    }
    const entry = Object.values(country_1.ORGANIZATION_COUNTRY_MAP).find((mapping) => mapping.countryCode === countryCode);
    return entry?.countryName ?? "NOT_SUPPORTED_COUNTRY";
};
exports.getSignupCountryFromCountryCode = getSignupCountryFromCountryCode;
const isEinSignupCountry = (country) => {
    return country !== country_1.CountryNames.Ireland;
};
exports.isEinSignupCountry = isEinSignupCountry;
const shouldSearchNonprofitRegisterAtSignup = (country, isTaxExemptChoice) => (0, exports.isEinSignupCountry)(country) && (isTaxExemptChoice || country === country_1.CountryNames.Germany);
exports.shouldSearchNonprofitRegisterAtSignup = shouldSearchNonprofitRegisterAtSignup;
const getEligibilityChoiceContent = (country) => {
    const isUS = country === country_1.CountryNames.UnitedStates;
    const isGB = country === country_1.CountryNames.UnitedKingdom;
    const isIE = country === country_1.CountryNames.Ireland;
    const isDE = country === country_1.CountryNames.Germany;
    const isAuNz = country === country_1.CountryNames.Australia || country === country_1.CountryNames.NewZealand;
    return {
        displayTaxExemptChoice: !isAuNz && !isDE,
        displayOtherNonProfitChoice: !isIE,
        taxExemptTitleKey: isGB
            ? "signup.eligibilityCriteriaTaxExempt.GB"
            : isIE
                ? "signup.eligibilityCriteriaTaxExempt.IE"
                : isDE
                    ? "signup.eligibilityCriteriaTaxExempt.DE"
                    : "signup.eligibilityCriteriaTaxExempt",
        taxExemptDescriptionKey: isUS
            ? "signup.eligibilityCriteriaTaxExemptDescription.US"
            : isGB
                ? "signup.eligibilityCriteriaTaxExemptDescription.GB"
                : isIE
                    ? "signup.eligibilityCriteriaTaxExemptDescription.IE"
                    : isDE
                        ? "signup.eligibilityCriteriaTaxExemptDescription.DE"
                        : "signup.eligibilityCriteriaTaxExemptDescription.Canada",
        otherNonProfitTitleKey: isGB
            ? "signup.eligibilityCriteriaOtherNonProfit.GB"
            : isDE
                ? "signup.eligibilityCriteriaOtherNonProfit.DE"
                : isAuNz
                    ? "signup.eligibilityCriteriaTaxExempt.AuNz"
                    : "signup.eligibilityCriteriaOtherNonProfit",
        otherNonProfitDescriptionKey: isUS
            ? "signup.eligibilityCriteriaOtherNonProfitDescription.US"
            : isGB
                ? "signup.eligibilityCriteriaOtherNonProfitDescription.GB"
                : isDE
                    ? "signup.eligibilityCriteriaOtherNonProfitDescription.DE"
                    : isAuNz
                        ? "signup.eligibilityCriteriaTaxExemptDescription.AuNz"
                        : "signup.eligibilityCriteriaOtherNonProfitDescription.Canada",
    };
};
exports.getEligibilityChoiceContent = getEligibilityChoiceContent;
